module.exports = __webpack_public_path__ + "static/media/listloader.d9ef970f.svg";